
let report_options_children = [
    { label: "年报", value: "Q14" },
    { label: "半年报", value: "Q12" },
    // { label: "季报", value: "" },
    { label: "4季报", value: "Q44" },
    { label: "3季报", value: "Q33" },
    { label: "2季报", value: "Q22" },
    { label: "1季报", value: "Q11" },
]
/*
    初始化报告期
    取当前年份及前3年
*/
function initReportOptions(report_options) {
    let year = new Date().getFullYear()
    for(let i = 0; i < 4; i++) {

        let temp_label = year - i  + '年'
        let temp_value = year - i  + ''
        let obj = {label: temp_label, value: temp_value, filterable: false, children:  report_options_children}
        report_options.push(obj)
    }
}

/*
    报告期code转为中文
*/
function reportTrans(array) {
    array.forEach(element => {
        if(!element||!element['report_period']) return
        var data_array = element.report_period.split('Q')
        let season = ""
        switch (data_array[1]) {
            case '11':
                season = "1季报"
                break;
            case '22':
                season = "2季报"
                break;
            case '33':
                season = "3季报"
                break;
            case '44':
                season = "4季报"
                break;
            case '12':
                season = "半年报"
                break;
            case '14':
                season = "年报"
                break;
            default:
                break;
        }
        element.report_period = data_array[0] + '年' + season
    });
}
export {reportTrans as reportTrans, initReportOptions as initReportOptions }



// WEBPACK FOOTER //
// ./src/fund_esg/js/report_trans.js